import { Paper, Stack, Text } from '@mantine/core';
import { MetricRow } from '../../atlas/cards/MetricRow';
import { ASWP_PLACEMENT_RATE_GOAL_PCT, type AswpProgramSnapshot } from './mapAswpComponentProjectData';

function formatPlacementPct(value: number | null): string {
  if (value === null) return '—';
  return `${value.toFixed(1)}%`;
}

export type ProgramParticipationPanelProps = {
  programLabel: string;
  allTime: AswpProgramSnapshot;
  placementRateGoal?: number;
};

export function ProgramParticipationPanel({
  programLabel,
  allTime,
  placementRateGoal = ASWP_PLACEMENT_RATE_GOAL_PCT,
}: ProgramParticipationPanelProps) {
  return (
    <Paper
      radius="md"
      p="md"
      sx={(theme) => ({
        height: '100%',
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.white,
        border: `1px solid ${theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[2]}`,
      })}
    >
      <Stack spacing="md">
        <Text size="sm" weight={700}>
          {programLabel}
        </Text>

        <MetricRow
          items={[
            {
              label: 'Participation (All-Time)',
              labelTooltip: `Total participants in ${programLabel} across all reported quarters (includes periods not shown).`,
              value: (
                <Text size="md" weight={800}>
                  {allTime.participation}
                </Text>
              ),
            },
            {
              label: 'Placement (All-Time)',
              labelTooltip: `Total participants placed in jobs from ${programLabel} across all time (includes periods not shown).`,
              value: (
                <Text size="md" weight={800}>
                  {allTime.placement}
                </Text>
              ),
            },
            {
              label: 'Placement Rate (All-Time)',
              labelTooltip: `Percent of all-time participants placed in jobs (placement ÷ participation). Grant target: ${placementRateGoal}% placement by end of Year 5.`,
              value: (
                <Text size="md" weight={800}>
                  {formatPlacementPct(allTime.placementPct)}
                </Text>
              ),
              sublabel: `Goal ${placementRateGoal}%`,
            },
          ]}
        />
      </Stack>
    </Paper>
  );
}
